/**
 * Looping ticker — paper/cream variant or dark variant.
 */
const DEFAULT_ITEMS = [
  "Amazon.de — Europe's largest marketplace",
  "€0 import duty from Ireland",
  "One VAT registration, 27 countries",
  "DUB → BER → PAR → AMS",
  "10–12 weeks to first sale",
  "Pricing on the page",
];

export default function Ticker({ items = DEFAULT_ITEMS, variant = "dark" }) {
  const cls =
    variant === "dark"
      ? "border-t border-white/10 bg-navy-deep/60 backdrop-blur-sm"
      : "border-y border-line bg-paper";
  const txt =
    variant === "dark" ? "text-white/35" : "text-ink-muted";
  const sep =
    variant === "dark" ? "text-coral" : "text-coral";

  // Duplicate for seamless loop
  const row = (key) => (
    <span
      key={key}
      className={`font-mono text-[10.5px] tracking-[0.26em] uppercase ${txt} whitespace-nowrap flex items-center gap-7 px-7`}
    >
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-7">
          <span>{it}</span>
          <b className={`${sep} font-normal`}>·</b>
        </span>
      ))}
    </span>
  );

  return (
    <div className={`overflow-hidden py-4 ${cls}`} data-testid="ticker">
      <div className="ticker-row">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
